// import { useEffect, useState } from 'react';
// import api from 'src/api';

// type KeyIdPair = { key: string, id: any };
// type QueueItem = KeyIdPair & { state: 'added' | 'fetching', retriedTimes: number, onFetched: (item: any) => void }

// const queue: Array<QueueItem> = [];
// const cache: Array<KeyIdPair & { item: any }> = [];

// export function usePreloaded<T>(key: string, id: any): T | undefined {
//     const freshItemInCache = cache.find(i => i.id == id && i.key == key);

//     const [existing, setExisting] = useState(freshItemInCache);

//     useEffect(() => {
//         if (!freshItemInCache) {
//             queue.push({
//                 key, id, retriedTimes: 0, state: 'added', onFetched: (item) => {
//                     setExisting(item);
//                 }
//             })
//         } else {
//             setExisting(freshItemInCache);
//         }
//     }, [key, id, freshItemInCache]);

//     // useEffect(() => {
//     //     if (freshItemInCache != existing) {
//     //         setExisting(freshItemInCache);
//     //     }
//     // }, [freshItemInCache, existing]);

//     return existing?.item;
// }

// function startFetching() {
//     setInterval(async () => {
//         const groups = groupBy(queue.filter(i => i.state == 'added'), 'key');

//         for (const key in groups) {
//             groups[key].forEach(i => i.state = 'fetching');

//             if (key == 'survey') {
//                 try {
//                     // todo: api to fetch by ids
//                     const pagedItems = await api.surveys.getList({}, {});
//                     const allItems = pagedItems.items;

//                     groups[key].forEach(queueItem => {
//                         const fetchedItem = allItems.find(i => i.id == queueItem.id);
//                         // console.log('AAA', fetchedItem, queueItem);
//                         if (fetchedItem) {
//                             updateCache(key, queueItem.id, fetchedItem);
//                             queueItem.onFetched(fetchedItem);
//                             removeItemFromQueue(queueItem);
//                         } else {
//                             queueItem.retriedTimes++;
//                         }
//                     })
//                 } catch (e) {
//                     groups[key].forEach(i => {
//                         if (i.retriedTimes == 0) {
//                             i.state = 'added';
//                             i.retriedTimes++;
//                         } else {
//                             removeItemFromQueue(i);
//                         }
//                     });
//                 }
//             }
//         }
//     }, 100);
// }

// function removeItemFromQueue(queueItem: QueueItem) {
//     queue.splice(queue.indexOf(queueItem), 1);
// }

// function updateCache(key: string, id: any, item: any) {
//     const existing = cache.find(i => i.id == id && i.key == key);

//     cache.splice(cache.indexOf(existing, 1));

//     cache.push({ id, item, key });
// }

// // function removeItemFromQueue()

// startFetching();

// function groupBy<T extends Array<any>>(xs: T, key: keyof T[0]): { [key: string]: T } {
//     return xs.reduce(function (rv, x) {
//         (rv[x[key]] = rv[x[key]] || []).push(x);
//         return rv;
//     }, {});
// };

import DataLoader from 'dataloader';
import { useEffect, useState } from 'react';
import api from 'src/api';
import { SurveyServerModel } from 'src/data/types/surveys/types';

let globalSurveys: Array<SurveyServerModel> = [];

async function loadIfNotLoaded() {
    if (globalSurveys.length == 0) {
        const items = await api.surveys.getList({ pageSize: 500 }, {})

        globalSurveys = items.items;

        return globalSurveys;
    } else {
        return globalSurveys;
    }
}

async function batchFunction(surveyIds) {
    const response = await loadIfNotLoaded();

    return response.filter(i => surveyIds.indexOf(i.id) !== -1);
}
export const surveysLoader = new DataLoader(batchFunction, {
    batchScheduleFn: callback => setTimeout(callback, 100),
});

export function useSurveyBare(surveyId: string, trigger: boolean = true): { survey: SurveyServerModel } {
    const [survey, setSurvey] = useState(null);

    useEffect(() => {
        if (!trigger) return;
        if (!surveyId) return;

        const fetchSurvey = async () => {
            const survey = await surveysLoader.load(surveyId);

            setSurvey(survey);
        };

        fetchSurvey();
    });

    return {
        // isLoading,
        survey,
    };
}
